// extracted by mini-css-extract-plugin
export default {"top":"JobsApp_top__eZ46y","box":"JobsApp_box__odMop","addButton":"JobsApp_addButton__3r9E+"};